import React, { useState } from 'react';

import toast from 'react-hot-toast';

import { useAuth } from '../../../hooks/auth';
import { useForm } from 'react-hook-form';
import { trim } from 'lodash';
import Joi from 'joi';
import { joiResolver } from '@hookform/resolvers/joi';

import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import MessageErrorValidator from '../../../components/MessageErrorValidator';

import { FiLock, FiUser } from 'react-icons/fi';

import { Container, ModalForgetContainer, PAlert } from './styles';

import api from '../../../services/api';
import { API_S3 } from '../../../services/api_s3';
import LoaderAtomic from '../../../components/LoaderAtomic';

import logoWhiteHorizontal from '../../../assets/logo/logo-small-w.png';

const SignIn: React.FC = () => {
  // Validation login
  const { handleSubmit, setValue, formState: { errors }, reset, register } = useForm({
    resolver: async (data, context, options) => {
      console.log('formData', data);
      console.log(
        'validation result',
        await joiResolver(schema)(data, context, options),
      );

      return joiResolver(schema)(data, context, options);
    },
  });

  // Validation send email forget password
  const { handleSubmit: handleSubmit2, setValue: setValue2, formState: { errors: errors2 }, reset: reset2, register: register2 } = useForm({
    resolver: async (data, context, options) => {
      console.log('formData', data);
      console.log(
        'validation result',
        await joiResolver(schema2)(data, context, options),
      );
      return joiResolver(schema2)(data, context, options);
    },
  });

  // Schema forget password
  const schema = Joi.object({
    email: Joi.string().email({ tlds: { allow: false } }).required().messages({ '*': 'Informe um e-mail válido.', 'string.email': 'Informe um e-mail válido.' }),
    password: Joi.string().required().messages({
      '*': 'Informe uma senha válida.',
      'string.min': `O campo senha deve ter no mínimo {#limit} caracteres`,
      'string.max': `O campo senha deve ter no máximo {#limit} caracteres`,
    }),
  });

  // Schema forget password
  const schema2 = Joi.object({
    email: Joi.string().email({ tlds: { allow: false } }).required().messages({ '*': 'Informe um e-mail válido.', 'string.email': 'Informe um e-mail válido.' }),
  });

  const { login } = useAuth();
  const BG = `${API_S3}/default/login/login1.webp`

  //Loader
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  // Modals
  const [openModal, setOpenModal] = useState(false);

  // Form
  const onSubmit = handleSubmit(async (data) => {
    try {
      setButtonLoading(true);
      //console.log(data);

      const emailTrined = trim(data.email.replace(/\s/g, '')).trim().toLocaleLowerCase();

      await login({
        email: emailTrined,
        password: data.password
      });
    }
    catch (error) {
      console.log(error);
      toast.error('Desculpe, as informações de login fornecidas não correspondem a nenhum usuário cadastrado. Verifique se o endereço de e-mail e a senha estão corretos e tente novamente. 😉',
        {
          position: 'bottom-right',
          duration: 10000,

        }
      );
    }
    finally {
      setButtonLoading(false);
    }
  });

  const onSubmitForgetPassword = handleSubmit2(async data => {
    try {
      console.log(data);
      setLoading(true);
      const emailTrined = trim(data.email.replace(/\s/g, '')).trim().toLocaleLowerCase();

      const response = await api.post('/passwords/forgot', {
        email: emailTrined,
      });

      console.log(response.data);

      toast.success('O e-mail de redefinição de senha foi enviado com sucesso para o endereço de e-mail especificado. Verifique a sua caixa de entrada para mais detalhes. 😉', {
        position: 'bottom-right',
        duration: 7000,

      });

      setOpenModal(false);
    } catch (error: any) {
      console.log(error);

      if (error.response.data.error === 'user-not-found') {
        toast.error('Desculpe, não encontramos nenhum usuário com o nome ou informações especificadas. Por favor, verifique se as informações estão corretas e tente novamente. 😉', {
          position: 'bottom-right',
          duration: 10000,

        });

        return;
      }

      toast.error('Ops! Algo deu errado. Verifique o email informado e tente novamente.', {
        position: 'bottom-center',
        duration: 10000,
      });

      reset2();

      setLoading(false);
    } finally {
      setLoading(false);
    }
  });

  return (
    <>
      {loading && <LoaderAtomic isVisible={loading} />}
      <Container style={{ backgroundImage: `url(${BG})` }}>
        <main>
          <section>
            <aside style={{ backgroundImage: `url(${BG})` }}>
              <h3>Professor Gabriel Cabral</h3>
              <p>Seja bem vindo a melhor plataforma de ensino de Química do Brasil.</p>
            </aside>
            <main>
              <header>
                <img src={logoWhiteHorizontal} alt="Logo" />
              </header>
              <div>
                <p>Preencha os campos abaixo com as suas credenciais para acessar a melhor plataforma de ensino de Química do Brasil.</p>
              </div>
              <form onSubmit={onSubmit}>
                <div>
                  <aside>
                    <FiUser size={25} />
                  </aside>
                  <main>
                    <label>E-mail:</label>
                    <input {...register("email")} type="text" />
                  </main>
                </div>
                <div>
                  <aside>
                    <FiLock size={25} />
                  </aside>
                  <main>
                    <label>Senha:</label>
                    <input {...register("password")} type="password" />
                  </main>
                </div>
                {errors?.email?.message && <MessageErrorValidator>❌ {errors?.email?.message as string}</MessageErrorValidator>}
                <p>Não está conseguindo acessar? <span onClick={() => setOpenModal(true)}>Redefina a sua senha.</span>
                </p>
                <footer>
                  <Button type="submit" color="primary" loading={buttonLoading}>Entrar</Button>
                  <p>© {new Date().getFullYear()} - Desenvolvido por: Px Tecnologia</p>
                </footer>
              </form>
            </main>
          </section>
        </main>
      </Container>

      {/* MODALS */}
      <Modal
        isOpen={openModal}
        setIsOpen={() => setOpenModal(!openModal)}
        closeModal={() => setOpenModal(false)}
        size="lg"
        background="#ffffff"
        border="3px solid #3e3f5e11"
        titleColor="#3e3f5e"
        height="auto"
      >
        <ModalForgetContainer>
          <h1>Esqueceu sua senha? 😐</h1>
          <p>
            Por favor, informe o endereço de e-mail que você forneceu durante a compra para que possamos lhe enviar instruções de como trocar a sua senha.
          </p>
          <main>
            <form onSubmit={onSubmitForgetPassword}>
              <label>Informe o seu e-mail</label>
              <input type="text" {...register2("email")} autoComplete="off" />
              {errors2?.email?.message && <MessageErrorValidator>{errors2?.email?.message as string}</MessageErrorValidator>}

              <Button type="submit" color="primary" disabled={loading}>Recuperar senha</Button>
              <PAlert>Se você não receber um e-mail de redefinição de senha em alguns minutos, verifique sua caixa de spam ou entre em contato com o suporte. 😉</PAlert>
            </form>
          </main>
        </ModalForgetContainer>
      </Modal>
    </>
  );
}

export default SignIn;